import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export const customerDOBDisabledDate = (current: dayjs.Dayjs) => {
  // Can only select dates older than 10 years
  return current && current >= dayjs().subtract(10, 'years');
};

export const disableAllDatesBeforeTomorrow = (current: dayjs.Dayjs) => {
  // Can not select days before tomorrow
  return current && current < dayjs().endOf('day');
};

export const disableAllDatesBeforeToday = (current: dayjs.Dayjs) => {
  // Can not select days before tomorrow
  return current && current < dayjs().subtract(1, 'day').endOf('day');
};

export const disableAllDatesAMonthAgo = (current: dayjs.Dayjs) => {
  // Can only select dates older than 10 years
  return current && current < dayjs().subtract(1, 'months');
};

export const disableAllDatesAWeekAgo = (current: dayjs.Dayjs) => {
  // Can only select dates older than 10 years
  return current && current < dayjs().subtract(7, 'days');
};

export const formatToReadableDate = (uglyDate: dayjs.ConfigType, tz?: string) => {
  if (!uglyDate) {
    return '-';
  }

  if (tz) {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    return dayjs(uglyDate).tz(tz).format('ddd, MMM D, YYYY h:mm A');
  }

  return dayjs(uglyDate).format('ddd, MMM D, YYYY h:mm A');
};
